import { ICellRendererParams } from '@mint-lib/ag-grid/community';
import {
  Avatar,
  AvatarFallback,
  typographyVariants,
} from '@mint-lib/tw-components';

import { RagTableType } from '../../../../types/rag.js';

const UserCell = ({
  value,
}: Pick<ICellRendererParams<RagTableType>, 'value'>) => {
  const [firstName, lastName] = value.split('_');

  return (
    <div className="flex h-full flex-row items-center gap-2">
      <Avatar size="small">
        <AvatarFallback firstName={firstName} lastName={lastName} />
      </Avatar>
      <p
        className={typographyVariants({ variant: 'bodyShort01' })}
      >{`${firstName} ${lastName}`}</p>
    </div>
  );
};

export { UserCell };
